/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-return-assign */
/* eslint-disable no-nested-ternary */
import React, {
  useContext,
  // , useEffect
} from 'react'
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes as RoutesRouter,
  // useLocation,
  // useNavigate,
} from 'react-router-dom'
import { UsersAdm } from './pages/UsersAdm/UsersAdm'
import { LayoutPage } from './layouts/BaseLayout/LayoutPage'
import { Dashboard } from './pages/Dashboard'
import { Login } from './pages/Login/Login'
import { PredictionDetails } from './pages/PredictionDetails/PredictionDetails'
import { Predictions } from './pages/Predictions/Predictions'
import { Products } from './pages/Products/Products'
import { ProductsDetails } from './pages/ProductsDetails/ProductsDetails'
import { AuthContext, AuthProvider } from './contexts/AuthContext/AuthContext'
import { Logout } from './pages/Login/Logout'
import { ClientDetails } from './pages/ClientDetails/ClientDetails'
import { Sales } from './pages/Sales/Sales'
import { SalesPeople } from './pages/SalesPeople/SalesPeople'
import { Companies } from './pages/Companies/Companies'
import { SpreadSheets } from './pages/SpreadSheets/SpreadSheets'
import { Users } from './pages/Users/Users'
import { EditUser } from './pages/EditUser/EditUser'
import { NewUsers } from './pages/NewUsers/NewUsers'
import { SalesPeopleDetails } from './pages/SalesPeopleDetails/SalesPeopleDetails'
import { OrganizationList } from './components/OrganizationList'
import { apiService } from './services/_config_/apiservice'
import { useOrganization } from './components/OrganizationList/useOrganization'
import { useOrganizationList } from './components/OrganizationList/useOrganizationList'
import { DashboardOrganization } from './pages/Dashboard/DashboardOrganizationMock'
import { SheetsStatus } from './pages/SpreadSheets/SheetsStatus'
import { CompaniesDetails } from './pages/CompaniesDatails/CompaniesDetails'
import { useTopUserData } from './components/Top/TopUserData/useTopUserData'
import { Organizacoes } from './pages/Organizacoes'
import { OrganizacaoDetalhe } from './pages/Organizacoes/Detalhe'
import { Mapas } from './pages/Mapas/Mapas'
import { Administrativo } from './pages/Adm'
import { ADM } from './components/ADM/ADM'
import { NewUserAdm } from './pages/UsersAdm/newUserAdm'
import { Clientes } from './pages/Clientes/Clientes'
import { HistoricoBaixa } from './pages/HistoricoBaixa/HistoricoBaixa'
import { HistoricoBaixaDetails } from './pages/HistoricoBaixaDetails/HistoricoBaixaDetails'
import { MensagensEnviadas } from './pages/MensagensEnviadas/MensagensEnviadas'
import { MensagensEnviadasDetalhe } from './pages/MensagensEnviadasDetalhe/MensagensEnviadasDetalhe'
import { AlteraSenha } from './pages/AlteraSenha/AlteraSenha'
import { Configuracoes } from './pages/Configuracoes/Configuracoes'
import { PredictAnalytics } from './pages/PredictAnalytics/PredictAnalytics'
import { MixAdmin } from './pages/MixAdmin/MixAdmin'
import { GestaoTenants } from './pages/GestaoTenants/GestaoTenants'
import { GestaoTenantDetalhe } from './pages/GestaoTenants/Detalhe/GestaoTenantDetalhe'
import { CentralResultados } from './pages/CentralResultados/CentralResultados'
import { CentralResultadosDetalhe } from './pages/CentralResultados/Detalhe/CentralResultadosDetalhe'

function AccessPrivateRoute({ children }: { children: React.ReactNode }) {
  const { authentified } = useContext(AuthContext)
  const { useOrganizationsList } = useOrganizationList()
  const tenantId =
    useOrganizationsList != null &&
    useOrganizationsList.map(organizacao => organizacao.tenantId)

  const isTenantId =
    Array.isArray(tenantId) && tenantId.length > 0 ? tenantId[0] : ''

  const XTENANTID = localStorage.getItem('X-TENANT-ID')
  const { doOrganization } = useOrganization(isTenantId)
  if (!authentified) {
    return <Logout />
  }

  if (authentified) {
    if (XTENANTID === null) {
      if (useOrganizationsList != null && useOrganizationsList.length >= 2) {
        return <Navigate to="/organizacao" />
      }
      if (useOrganizationsList != null && useOrganizationsList.length === 1) {
        doOrganization()
      }
    }

    if (XTENANTID) {
      const XTENANTIDConvert = JSON.parse(XTENANTID)
      apiService.defaults.headers.common['X-TENANT-ID'] = `${XTENANTIDConvert}`
    }
  }

  return <LayoutPage>{children}</LayoutPage>
}

export function Routes() {
  const { userDataOrganization, userData, adm } = useTopUserData()

  // Predict Analytics e Mix Inteligente deixaram de ser so-admin: VENDEDOR, ASSISTENTE e
  // COORDENADOR tambem os abrem, cada um com os dados recortados pela propria carteira (o recorte
  // e do BACKEND — `EscopoVendedor`, PD-0004; aqui so se decide se a rota existe). O que continua
  // valendo e a flag do modulo por tenant: quem nao contratou nao ve, qualquer que seja o papel.
  const temVinculoNoTenant = userDataOrganization?.papelOrganizacao != null
  const veModulosDoTenant =
    userData?.papel === 'ADMINISTRADOR' ||
    (userData?.papel === 'USUARIO' && temVinculoNoTenant)

  const url = window.location.pathname
  const token = localStorage.getItem('token')
  if (
    (url === '/predicoes' ||
      url === '/dashboard' ||
      url === '/dashboard/produto/:id' ||
      url === '/predicao/:id' ||
      url === '/editar&perfil' ||
      url === '/newUser' ||
      url === '/usuarios&permissoes' ||
      url === '/planilhas-sucesso' ||
      url === '/planilhas-error' ||
      url === '/planilhas' ||
      url === '/empresas/:id' ||
      url === '/empresas' ||
      url === '/historico-baixa' ||
      url === '/historico-mensagens' ||
      url === '/configuracoes' ||
      url === '/predict-analytics' ||
      url === '/mix-inteligente' ||
      url === '/vendedores/:id' ||
      url === '/vendedores' ||
      url === '/vendas' ||
      url === '/clientes' ||
      url === '/cliente/:id' ||
      url === '/produtos/:id' ||
      url === '/produtos') &&
    token == null
  ) {
    window.location.href = '/logout'
  }

  return (
    <BrowserRouter>
      <AuthProvider>
        <RoutesRouter>
          <Route element={<Login />} path="/" />
          <Route element={<AlteraSenha />} path="/recuperacao" />
          <Route element={<Logout />} path="/logout" />
          <Route element={<Logout />} />

          <Route
            element={
              <LayoutPage>
                <DashboardOrganization />
                <OrganizationList />
              </LayoutPage>
            }
            path="/organizacao"
          />
          <Route
            element={
              <AccessPrivateRoute>
                <DashboardOrganization />
              </AccessPrivateRoute>
            }
            path="/dashboard1"
          />
          <Route
            element={
              <AccessPrivateRoute>
                <ADM />
              </AccessPrivateRoute>
            }
            path="/admin"
          />

          {/* Edicao do proprio perfil (dados/senha/WhatsApp pessoal): disponivel
              a qualquer usuario autenticado — nao depende de papel nem de
              userDataOrganization (que pode nao ter carregado / usuario inativo
              na organizacao). Antes vivia so no bloco de admin, o que deixava o
              vendedor com tela em branco. */}
          <Route
            element={
              <AccessPrivateRoute>
                <EditUser />
              </AccessPrivateRoute>
            }
            path="/editar&perfil"
          />

          {/* Predict Analytics (PD-0001): qualquer perfil com vinculo no tenant, E com o modulo
              habilitado (visibilidade) para o tenant selecionado. Ver `veModulosDoTenant`. */}
          {veModulosDoTenant &&
          userDataOrganization?.moduloPredictAnalyticsAtivo ? (
            <Route
              element={
                <AccessPrivateRoute>
                  <PredictAnalytics />
                </AccessPrivateRoute>
              }
              path="/predict-analytics"
            />
          ) : null}

          {/* Central de Resultados (PD-0007): mesmo publico e mesma guarda da Gestao de Tenants -
              super-admin GLOBAL. As duas telas respondem perguntas diferentes sobre a mesma conta
              ("usa o produto?" x "a carteira melhorou?") e se linkam entre si. */}
          {userData?.papel === 'ADMINISTRADOR' && adm === 'administrador' ? (
            <>
              <Route
                element={
                  <AccessPrivateRoute>
                    <CentralResultados />
                  </AccessPrivateRoute>
                }
                path="/adm-central-resultados"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <CentralResultadosDetalhe />
                  </AccessPrivateRoute>
                }
                path="/adm-central-resultados/:tenantId"
              />
            </>
          ) : null}

          {/* Mix Inteligente - painel do Mix (PD-0002): qualquer perfil com vinculo no tenant, E
              com o modulo habilitado (visibilidade) para o tenant selecionado. */}
          {veModulosDoTenant &&
          userDataOrganization?.moduloMixInteligenteAtivo ? (
            <Route
              element={
                <AccessPrivateRoute>
                  <MixAdmin />
                </AccessPrivateRoute>
              }
              path="/mix-inteligente"
            />
          ) : null}

          {userData?.papel === 'ADMINISTRADOR' ||
          (userData?.papel === 'USUARIO' &&
            userDataOrganization?.papelOrganizacao === 'ADMINISTRADOR') ? (
            <>
              <Route
                element={
                  <AccessPrivateRoute>
                    <Dashboard />
                  </AccessPrivateRoute>
                }
                path="/dashboard"
              />

              <Route
                element={
                  <AccessPrivateRoute>
                    <ProductsDetails />
                  </AccessPrivateRoute>
                }
                path="/dashboard/produto/:id"
              />
              {/* Origem do detalhe do cliente gravada na PROPRIA rota, como ja era feito para o
                  produto (/dashboard/produto/:id x /produtos/:id). Sem isso o menu lateral e o
                  botao voltar nao tinham como saber por onde o usuario entrou, e ficavam
                  cravados no Dashboard mesmo quando a entrada foi pela lista de Clientes. */}
              <Route
                element={
                  <AccessPrivateRoute>
                    <ClientDetails />
                  </AccessPrivateRoute>
                }
                path="/dashboard/cliente/:id"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <HistoricoBaixa />
                  </AccessPrivateRoute>
                }
                path="/historico-baixa"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <HistoricoBaixaDetails />
                  </AccessPrivateRoute>
                }
                path="/historico-baixa/:id"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <MensagensEnviadas />
                  </AccessPrivateRoute>
                }
                path="/historico-mensagens"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <MensagensEnviadasDetalhe />
                  </AccessPrivateRoute>
                }
                path="/historico-mensagens/:id"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <Configuracoes />
                  </AccessPrivateRoute>
                }
                path="/configuracoes"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <Predictions />
                  </AccessPrivateRoute>
                }
                path="/predicoes"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <PredictionDetails />
                  </AccessPrivateRoute>
                }
                path="/predicao/:id"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <Clientes />
                  </AccessPrivateRoute>
                }
                path="/clientes"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <ClientDetails />
                  </AccessPrivateRoute>
                }
                path="/clientes/:id"
              />
              {/* Rota legada: nada no app produz mais /cliente/:id, mas favorito antigo e link
                  copiado de versao anterior continuam abrindo a ficha — e voltando para o
                  Dashboard, exatamente como sempre voltaram. */}
              <Route
                element={
                  <AccessPrivateRoute>
                    <ClientDetails />
                  </AccessPrivateRoute>
                }
                path="/cliente/:id"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <Products />
                  </AccessPrivateRoute>
                }
                path="/produtos"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <ProductsDetails />
                  </AccessPrivateRoute>
                }
                path="/produtos/:id"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <Sales />
                  </AccessPrivateRoute>
                }
                path="/vendas"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <SalesPeople />
                  </AccessPrivateRoute>
                }
                path="/vendedores"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <SalesPeopleDetails />
                  </AccessPrivateRoute>
                }
                path="/vendedores/:id"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <Companies />
                  </AccessPrivateRoute>
                }
                path="/empresas"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <CompaniesDetails />
                  </AccessPrivateRoute>
                }
                path="/empresas/:id"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <SpreadSheets />
                  </AccessPrivateRoute>
                }
                path="/planilhas"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <SpreadSheets />
                    <SheetsStatus mensagem="failed" />
                  </AccessPrivateRoute>
                }
                path="/planilhas-error"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <SpreadSheets />
                    <SheetsStatus mensagem="sucesso" />
                  </AccessPrivateRoute>
                }
                path="/planilhas-sucesso"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <Users />
                  </AccessPrivateRoute>
                }
                path="/usuarios&permissoes"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <NewUsers />
                  </AccessPrivateRoute>
                }
                path="/newUser"
              />
            </>
          ) : (
            ''
          )}
          {/* Operacional (PD-0004): VENDEDOR, ASSISTENTE e COORDENADOR veem as mesmas telas de
              atendimento. O que muda e o ESCOPO de dados, resolvido no backend pelos CPFs
              vinculados. O coordenador soma a estas as telas de equipe do bloco seguinte.

              Clientes, Produtos e Historico de Baixas moraram aqui: eram do bloco do coordenador,
              e passaram para ca porque os tres perfis as pediram. Nao ha nada a liberar no backend
              — ClienteService, ProdutoService e HistoricoBaixaService ja recortam pelo
              `EscopoVendedor`, entao cada perfil ve so o que lhe cabe. Sao registradas UMA vez: a
              mesma `path` em dois blocos irmaos do mesmo <Routes> seria rota duplicada. */}
          {userData?.papel === 'USUARIO' &&
          (userDataOrganization?.papelOrganizacao === 'VENDEDOR' ||
            userDataOrganization?.papelOrganizacao === 'ASSISTENTE' ||
            userDataOrganization?.papelOrganizacao === 'COORDENADOR') &&
          adm === '' ? (
            <>
              <Route
                element={
                  <AccessPrivateRoute>
                    <Dashboard />
                  </AccessPrivateRoute>
                }
                path="/dashboard"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <ProductsDetails />
                  </AccessPrivateRoute>
                }
                path="/dashboard/produto/:id"
              />
              {/* Origem do detalhe do cliente gravada na PROPRIA rota, como ja era feito para o
                  produto (/dashboard/produto/:id x /produtos/:id). Sem isso o menu lateral e o
                  botao voltar nao tinham como saber por onde o usuario entrou, e ficavam
                  cravados no Dashboard mesmo quando a entrada foi pela lista de Clientes. */}
              <Route
                element={
                  <AccessPrivateRoute>
                    <ClientDetails />
                  </AccessPrivateRoute>
                }
                path="/dashboard/cliente/:id"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <Predictions />
                  </AccessPrivateRoute>
                }
                path="/predicoes"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <PredictionDetails />
                  </AccessPrivateRoute>
                }
                path="/predicao/:id"
              />

              <Route
                element={
                  <AccessPrivateRoute>
                    <ClientDetails />
                  </AccessPrivateRoute>
                }
                path="/cliente/:id"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <Clientes />
                  </AccessPrivateRoute>
                }
                path="/clientes"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <ClientDetails />
                  </AccessPrivateRoute>
                }
                path="/clientes/:id"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <Products />
                  </AccessPrivateRoute>
                }
                path="/produtos"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <ProductsDetails />
                  </AccessPrivateRoute>
                }
                path="/produtos/:id"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <HistoricoBaixa />
                  </AccessPrivateRoute>
                }
                path="/historico-baixa"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <HistoricoBaixaDetails />
                  </AccessPrivateRoute>
                }
                path="/historico-baixa/:id"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <Sales />
                  </AccessPrivateRoute>
                }
                path="/vendas"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <MensagensEnviadas />
                  </AccessPrivateRoute>
                }
                path="/historico-mensagens"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <MensagensEnviadasDetalhe />
                  </AccessPrivateRoute>
                }
                path="/historico-mensagens/:id"
              />
            </>
          ) : (
            ''
          )}

          {/* Acompanhamento de equipe (PD-0004): SO o COORDENADOR. Sao as telas gerenciais que o
              vendedor/assistente nao ve. Continuam fora: planilhas, usuarios e configuracoes
              (admin do tenant, com 403 real no backend para Predict/Mix ADMIN de organizacao).
              Clientes, Produtos e Historico de Baixas saíram daqui para o bloco operacional acima
              — passaram a valer para os tres perfis. */}
          {userData?.papel === 'USUARIO' &&
          userDataOrganization?.papelOrganizacao === 'COORDENADOR' &&
          adm === '' ? (
            <>
              <Route
                element={
                  <AccessPrivateRoute>
                    <SalesPeople />
                  </AccessPrivateRoute>
                }
                path="/vendedores"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <SalesPeopleDetails />
                  </AccessPrivateRoute>
                }
                path="/vendedores/:id"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <Companies />
                  </AccessPrivateRoute>
                }
                path="/empresas"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <CompaniesDetails />
                  </AccessPrivateRoute>
                }
                path="/empresas/:id"
              />
            </>
          ) : (
            ''
          )}
          {(userData?.papel === 'ADMINISTRADOR' && adm === 'administrador') ||
          (userData?.papel === 'USUARIO' &&
            userDataOrganization?.papelOrganizacao === 'ADMINISTRADOR' &&
            adm === 'administrador') ? (
            <>
              <Route
                element={
                  <AccessPrivateRoute>
                    <Administrativo />
                  </AccessPrivateRoute>
                }
                path="/administrador"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <UsersAdm />
                  </AccessPrivateRoute>
                }
                path="/adm-user"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <Organizacoes />
                  </AccessPrivateRoute>
                }
                path="/adm-organizacao"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <OrganizacaoDetalhe />
                  </AccessPrivateRoute>
                }
                path="/adm-organizacao/novo"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <OrganizacaoDetalhe />
                  </AccessPrivateRoute>
                }
                path="/adm-organizacao/:id"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <Mapas />
                  </AccessPrivateRoute>
                }
                path="/adm-mapa"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <NewUserAdm />
                  </AccessPrivateRoute>
                }
                path="/new-user-adm"
              />
            </>
          ) : (
            ''
          )}

          {/* Gestão de Tenants (PD-0003): control plane SÓ super-admin GLOBAL (o backend responde
              403 a admin de tenant). Diferente de Predict/Mix (que aceitam admin do tenant). */}
          {userData?.papel === 'ADMINISTRADOR' && adm === 'administrador' ? (
            <>
              <Route
                element={
                  <AccessPrivateRoute>
                    <GestaoTenants />
                  </AccessPrivateRoute>
                }
                path="/adm-gestao-tenants"
              />
              <Route
                element={
                  <AccessPrivateRoute>
                    <GestaoTenantDetalhe />
                  </AccessPrivateRoute>
                }
                path="/adm-gestao-tenants/:tenantId"
              />
            </>
          ) : null}
        </RoutesRouter>
      </AuthProvider>
    </BrowserRouter>
  )
}
